import { NavigationEnd, Router, RouterModule } from '@angular/router';
import {
  DsBoxModule,
  DsButtonModule,
  DsHeaderModule,
  DsHeaderTagConfiguration,
  DsHeaderUserInfo,
  DsImprintModule,
  DsNavigationBarModule,
  DsNavigationItem,
} from '@bmw-ds/components';
import { CommonModule } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  effect,
  inject,
  signal,
  ViewChild,
  WritableSignal,
} from '@angular/core';
import { UserStateService } from './services/user-state.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    CommonModule,
    DsNavigationBarModule,
    DsHeaderModule,
    DsBoxModule,
    DsImprintModule,
    DsButtonModule,
    RouterModule,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  isLandingPage: boolean = false;

  @ViewChild('navBar') navBar: any;
  private readonly cdr = inject(ChangeDetectorRef);
  private userState = inject(UserStateService);
  private router= inject(Router);
  constructor() {
    // Set isLandingPage initially
    this.checkLandingPage(this.router.url);
    effect(() => {
      const name = this.userState.employeeName();
      this.userInfo.update((prev) => ({ ...prev, username: name }));
    });

    effect(() => {
      const department = this.userState.companyId();
      this.userInfo.update((prev) => ({ ...prev, department }));
    });
    // Then update it on every NavigationEnd event
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.checkLandingPage(event.urlAfterRedirects);
        this.cdr.detectChanges();
      }
    });
  }
  checkLandingPage(url: string) {
    this.isLandingPage = url === '/' || url.startsWith('/landing?');
  }

  environmentTagConfig: WritableSignal<Partial<DsHeaderTagConfiguration>> =
    signal({ label: 'DEV' });

  userInfo: WritableSignal<Partial<DsHeaderUserInfo>> = signal({
    username: '',
    department: '',
    profileImg: 'https://www.gravatar.com/avatar/?d=identicon',
  });

  navigationItems: WritableSignal<DsNavigationItem[]> = signal([
    {
      label: 'Vehicles',
      href: '/stock-search',
      icon: 'shopping_cart',
    },
    {
      label: 'Users',
      href: '/users',
      icon: 'file_text',
    },
    {
      label: 'Load Vehicles',
      icon: 'tire',
      href: '/load-vehicles',
    },
  ]);

  title = 'Dealer Bidding System';
}
